import { render } from "./PerksBlock.vue?vue&type=template&id=2a69b412"
import script from "./PerksBlock.vue?vue&type=script&lang=js"
export * from "./PerksBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__